import React from "react"

export function Upload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2_1904)">
        <path
          d="M9 3.41564V11C9 11.5531 8.55313 12 8 12C7.44688 12 7 11.5531 7 11V3.41564L4.70625 5.70939C4.31563 6.10001 3.68125 6.10001 3.29063 5.70939C2.9 5.31876 2.9 4.68439 3.29063 4.29376L7.29063 0.293762C7.68125 -0.0968628 8.31563 -0.0968628 8.70625 0.293762L12.7063 4.29376C13.0969 4.68439 13.0969 5.31876 12.7063 5.70939C12.3156 6.10001 11.6812 6.10001 11.2906 5.70939L9 3.41564ZM2 11H6C6 12.1031 6.89687 13 8 13C9.10312 13 10 12.1031 10 11H14C15.1031 11 16 11.8969 16 13V14C16 15.1031 15.1031 16 14 16H2C0.896875 16 0 15.1031 0 14V13C0 11.8969 0.896875 11 2 11ZM13.5 14.25C13.6989 14.25 13.8897 14.171 14.0303 14.0303C14.171 13.8897 14.25 13.6989 14.25 13.5C14.25 13.3011 14.171 13.1103 14.0303 12.9697C13.8897 12.829 13.6989 12.75 13.5 12.75C13.3011 12.75 13.1103 12.829 12.9697 12.9697C12.829 13.1103 12.75 13.3011 12.75 13.5C12.75 13.6989 12.829 13.8897 12.9697 14.0303C13.1103 14.171 13.3011 14.25 13.5 14.25Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1904">
          <path d="M0 0H16V16H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
